"use client";

// TODO: REMOVE - DEPRECATED
import { createContext, useContext, useState, useEffect } from "react";
import { BettorSettings } from "common";
import { useUser } from "@clerk/nextjs";

interface SettingsContextType {
  settings: BettorSettings | null;
  loading: boolean;
  error: string | null;
}

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

export const useSettings = () => {
  const context = useContext(SettingsContext);

  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }

  return context;
};

export const SettingsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [settings, setSettings] = useState<BettorSettings | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { user, isLoaded } = useUser();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        setError(null);

        const username = user?.username?.toLowerCase();

        if (!username) {
          setSettings(null);
          return;
        }

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/api/users/${username}/settings`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch settings: ${response.status} ${response.statusText}`
          );
        }

        const data = (await response.json()) as BettorSettings;

        console.log("user settings response:", data);

        setSettings(data);
      } catch (err) {
        setSettings(null);

        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unexpected error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    if (!isLoaded) return;

    if (user?.username) {
      fetchSettings();
    } else {
      setSettings(null);
      setLoading(false);
    }
  }, [user, isLoaded]);

  return (
    <SettingsContext.Provider value={{ settings, loading, error }}>
      {children}
    </SettingsContext.Provider>
  );
};